import React from "react";

export const fallbackOrders = [
  {
    id: "#3933",
    date: "4 April, 2021",
    total: 135,
    status: "Processing",
    items: [
      { productId: 5, quantity: 5 },
      { productId: 8, quantity: 2 },
      { productId: 10, quantity: 1 },
    ],
    billingAddress: {
      name: "Dainne Russell",
      address: "4140 Parker Rd. Allentown, New Mexico 31134",
      email: "dainne.russell@gmail.com",
      phone: "(671) 555-0110",
    },
    shippingAddress: {
      name: "Dainne Russell",
      address: "4140 Parker Rd. Allentown, New Mexico 31134",
      email: "dainne.russell@gmail.com",
      phone: "(671) 555-0110",
    },
    paymentMethod: "Paypal",
    discountRate: 0.2,
  },
  {
    id: "#5045",
    date: "27 Mar, 2021",
    total: 25,
    status: "On the way",
    items: [{ productId: 2, quantity: 1 }],
  },
  {
    id: "#5028",
    date: "20 Mar, 2021",
    total: 250,
    status: "Completed",
    items: [{ productId: 14, quantity: 4 }],
  },
  {
    id: "#4600",
    date: "19 Mar, 2021",
    total: 35,
    status: "Completed",
    items: [{ productId: 7, quantity: 1 }],
  },
  {
    id: "#4152",
    date: "18 Mar, 2021",
    total: 578,
    status: "Completed",
    items: [{ productId: 6, quantity: 13 }],
  },
  {
    id: "#8811",
    date: "10 Mar, 2021",
    total: 345,
    status: "Completed",
    items: [{ productId: 1, quantity: 7 }],
  },
];

export const navigationItems = [
  { key: "dashboard", label: "Dashboard", icon: "dashboard.png" },
  { key: "orders", label: "Order History", icon: "orderhistory.png" },
  { key: "wishlist", label: "Wishlist", icon: "wishlist.png" },
  { key: "cart", label: "Shopping Cart", icon: "shoppingcart.png" },
  { key: "settings", label: "Settings", icon: "settings.png" },
  { key: "logout", label: "Log-out", icon: "logout.png" },
];

export function formatCurrency(value) {
  return `$${Number(value).toFixed(2)}`;
}

export function splitFullName(fullName = "") {
  const parts = fullName.trim().split(" ").filter(Boolean);

  return {
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" "),
  };
}

export function ProfileAvatar({ currentUser }) {
  const initials = (currentUser?.name || "U")
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div
      style={{
        width: "96px",
        height: "96px",
        borderRadius: "50%",
        backgroundColor: "var(--greenG1)",
        backgroundImage: currentUser?.pfp ? `url(${currentUser.pfp})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--greenG9)",
        fontSize: "28px",
        fontWeight: 600,
        overflow: "hidden",
      }}
    >
      {!currentUser?.pfp ? initials : null}
    </div>
  );
}
